import serialize from "json-form-data";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

export default {
    namespaced: true,

    actions: {
        async loadDocuments(ctx, params) {
            const token = ctx.rootState.authToken;
            const {userId} = ctx.rootState;

            const {page} = params;
            delete params.page;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/documents-report/index&user_id=${userId}&page=${page}`, token),
                {
                    method: "POST",
                    body: serialize(params)
                }
            );

            const json = await res.json();

            return json;
        }
    }
};
